import useRunway from '../../../hooks/useRunway'
import { storagePage } from '../storage'

export default function useSelectedItems() {
    const { selectedItems, saveSelectedItems } = useRunway()
    const subtotal = selectedItems
        .map(selected =>
            selected.items.reduce((a, b) => {
                let restCost = 0
                if (b.modifier_groups) {
                    restCost = b.modifier_groups.reduce(
                        (c, d) =>
                            c +
                            d.modifier_group_modifiers.reduce(
                                (e, f) => e + f.price * f.quantity,
                                0
                            ),
                        0
                    )
                }
                return a + (b.price + restCost) * b.quantity

                //Esto era cuando el precio del item ya incluía los precios de las subcaracteristicas
                //return a + b.price * b.quantity
            }, 0)
        )
        .reduce((a, b) => a + b, 0)

    const discount =
        storagePage.typeDiscount === 'percentage'
            ? (subtotal / 100) * storagePage.discount
            : storagePage.discount
    const total = Number((subtotal - discount).toFixed(2))

    const valuePercentDiscount = storagePage.discount
    const totalCredit = storagePage.creditFees.reduce(
        (acc, curr) => acc + Number(curr.amount),
        0
    )

    return {
        subtotal,
        discount,
        total,
        totalCredit,
        valuePercentDiscount,
        typeDiscount: storagePage.typeDiscount,
        selectedItems,
        saveSelectedItems,
        deliveryPrice: storagePage.deliveryPrice
    }
}
